 
// Shared helpers for composing and updating tool execution chat messages

import { type ChatMessage, type ToolCall } from '../types/chat'

export function composeToolExecutionMessage(toolCall: ToolCall): ChatMessage {
  return {
    id: `tool_${toolCall.id}`,
    role: 'tool_execution',
    content: `Executing tool: ${toolCall.name}`,
    timestamp: Date.now(),
    toolCalls: [toolCall],
  }
}

export function applyToolUpdateToMessage(
  existing: ChatMessage,
  modifiedToolCall: ToolCall,
): Partial<ChatMessage> {
  const modifiedToolCalls = (existing.toolCalls || []).map(tc =>
    tc.id === modifiedToolCall.id ? modifiedToolCall : tc,
  )

  const statusSuffix = modifiedToolCall.success ? '✓' : '✗'
  const modifiedContent = `Tool executed: ${modifiedToolCall.name} ${statusSuffix}`

  return {
    toolCalls: modifiedToolCalls.length > 0 ? modifiedToolCalls : [modifiedToolCall],
    content: modifiedContent,
  }
}


